import Element from '../ui/Element';
import * as members from '../privates/privateMembers';

/**
 * @class MenuContainer
 * @summary A menu container is a container that holds the elements in a
 *  mobile menu.
 * @description
 *  You can add and remove elements to the container to customize
 *  your site's mobile menu. The menu only appears in the mobile version of your
 *  site.
 * @memberof $w
 * @queryable
 * @mixes $w.Element
 * @viewername wysiwyg.viewer.components.MenuContainer
 * @definitionId wysiwyg.viewer.components.MenuContainer
 * @tagname menuContainer
 */

class MenuContainer extends Element {
  /**
   * @function open
   * @summary Opens a mobile menu.
   * @description
   *  The `open()` function returns a Promise that is resolved when the
   *  mobile menu's container has finished opening.
   * @returns {Promise}
   * @fulfill {void} When the mobile menu has finished opening.
   * @snippet [MenuContainer-open.es6=Open a custom mobile menu]
   * @snippet [MenuContainer-open_then.es6=Open a custom mobile menu and log a message when done]
   * @see [close( )](#close)
   * @memberof $w.MenuContainer
   */
    open() {
        return new Promise((resolve) => {
            const RMI = members._RMI.get(this);

            const menuId = members._compId.get(this);

            RMI.executeCompBehavior(menuId, 'open', {}, resolve);
        });
    }

  /**
   * @function close
   * @summary Closes a mobile menu.
   * @description
   *  The `close()` function returns a Promise that is resolved when the
   *  custom mobile menu's container has finished closing.
   * @returns {Promise}
   * @fulfill {void} When the mobile menu has finished closing.
   * @snippet [MenuContainer-close.es6=Close a custom mobile menu]
   * @snippet [MenuContainer-close_then.es6=Close a custom mobile menu and log a message when done]
   * @see [open( )](#open)
   * @memberof $w.MenuContainer
   */
    close() {
        return new Promise((resolve) => {
            const RMI = members._RMI.get(this);

            const menuId = members._compId.get(this);

            RMI.executeCompBehavior(menuId, 'close', {}, resolve);
        });
    }
}

export default MenuContainer;
